import cookie from "cookie";

export default function isLoggedIn(): boolean {
  const { EdvalOS_AccessToken, EdvalOS_RefreshToken } = cookie.parse(document.cookie);

  return Boolean(EdvalOS_AccessToken !== undefined || EdvalOS_RefreshToken !== undefined);
}
